const Loading = () => {
    return (
        <div className="loadingFeedback">
               <div className="loader"></div>
        </div>
    )
}

export default Loading;